import { render, staticRenderFns } from "./SOPEditorMenu.vue?vue&type=template&id=51f10866&scoped=true&"
import script from "./SOPEditorMenu.vue?vue&type=script&lang=js&"
export * from "./SOPEditorMenu.vue?vue&type=script&lang=js&"
import style0 from "./SOPEditorMenu.vue?vue&type=style&index=0&id=51f10866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f10866",
  null
  
)

export default component.exports